import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgModule, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Cms} from '@impact/data';
import { TranslateModule } from '@ngx-translate/core';
import { LinkModule } from '../../link/link.module';
import { UtilsModule } from '../../utils/utils.module';

@Component({
    selector: 'app-image-links-grid-spot',
    template: `
        <section class="image-links-grid-spot">
            <h2 class="image-links-grid-spot__header">{{data.spotHeader}}</h2>

            <ul class="image-links-grid-spot__items">
                <ng-container *ngFor="let item of data.imageLinks">
                    <li class="image-links-grid-spot__item" *ngIf="item.itemLink">
                        <app-link [link]="item.itemLink" [classString]="'image-links-grid-spot__link'" [showLinkText]="false">
                            <img *ngIf="item.itemImage?.src"
                                [src]="item.itemImage.src | resolveMediaUrl: { format: 'webp', height: 60 }"
                                class="image-links-grid-spot__item-image"
                                [alt]="item.itemImage.alt"
                                loading="lazy" />
                            <div class="image-links-grid-spot__item-text" *ngIf="!item.displayImageOnly">
                                {{item.itemLink.name}}
                            </div>
                        </app-link>
                    </li>
                </ng-container>
            </ul>
        </section>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
class ImageLinksGridSpotComponent {
    @Input() data: Cms.ImageLinksGridSpot;
}

@NgModule({
    declarations: [ImageLinksGridSpotComponent],
    imports: [
        LinkModule,
        CommonModule,
        UtilsModule,
        RouterModule,
        TranslateModule.forChild()
    ]
})
class ImageLinksGridSpotModule {}

export const LazySpotComponent = ImageLinksGridSpotComponent;

